import { Modal } from '../../components/Modal';
import type { CalendarEventCreate, CalendarEventRead } from '../../types/api';
import { CalendarEventForm } from '../knowledge-base/CalendarEventsSection';

interface KeyDateModalProps {
  businessId: string;
  /** The key date being edited, or null for a new one. */
  initial: CalendarEventRead | null;
  /** Start date a new key date opens on. */
  defaultDate: string;
  isSaving: boolean;
  error: string | null;
  onSubmit: (body: CalendarEventCreate) => void;
  onDismiss: () => void;
}

/**
 * Key dates on the calendar screen are the knowledge base's `calendar_events` —
 * the same rows the pipeline grounds timely content on, edited where the user is
 * already looking at the month. The form itself is the knowledge base's, so the
 * validation rules and the autosaved draft are shared, not copied.
 */
export function KeyDateModal({
  businessId,
  initial,
  defaultDate,
  isSaving,
  error,
  onSubmit,
  onDismiss,
}: KeyDateModalProps) {
  return (
    <Modal
      title={initial === null ? 'Add event' : 'Edit event'}
      kind={initial === null ? 'new calendar event' : 'calendar event'}
      onDismiss={onDismiss}
    >
      <CalendarEventForm
        businessId={businessId}
        initial={initial}
        defaultStartsOn={defaultDate}
        isSaving={isSaving}
        error={error}
        onSubmit={onSubmit}
        onCancel={onDismiss}
      />
    </Modal>
  );
}
